import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';

class UserDetailPage extends React.Component {

    constructor(props) {
        super(props);

        let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");

        this.state = {
            user: {
                fio: '',
                email: '',
                login: '',
                password: '',
                role_id: null,
                // email: "test@test.ru",
                // fio: "тест",
                // login: "test_1",
                // password: "1",
                // role_id: "13",
            },
            returnUrl: returnUrl,
            needRedirect: false
        }
    }

    async componentDidMount() {
        try {
            if (!api.isUserAdmin()) {
                this.setState({
                    returnUrl: "/users/permission-denied",
                    needRedirect: true
                });

                return;
            }

            this.props.updateLoader({
                loaded: false,
                message: ""
            });

            if (this.props.match.params.id != 0) {
                const user = (await api.makeRequest(api.getUserDetails(this.props.match.params.id))).data.data;

                this.setState({
                    user,
                });
            }

            const roles = (await api.makeRequest(api.getUserRolesDictionary())).data.data;

            this.setState({
                roles,
            });

            this.props.updateLoader({
                loaded: true
            });

        } catch (err) {
            this.props.updateLoader({
                loaded: true,
                message: "Ошибка получения данных: " + err
            });
        }
    }

    render() {

        if (this.state.needRedirect) {
            return <Redirect to={this.state.returnUrl} />
        }

        return (
            <div>
                <h4 className="mb-4">{this.props.match.params.id == 0 ? "Регистрация пользователя " : "Редактирование данных пользователя"}</h4>

                <Formik
                    initialValues={this.state.user}
                    enableReinitialize={true}
                    validate={values => {
                        let errors = {};

                        if (!values.fio) {
                            errors.fio = 'Пожалуйста, заполните это поле';
                        };

                        if (!values.email) {
                            errors.email = 'Пожалуйста, заполните это поле';
                        };

                        if (!values.login) {
                            errors.login = 'Пожалуйста, заполните это поле';
                        };

                        if (this.props.match.params.id == 0 && !values.password) {
                            errors.password = 'Пожалуйста, заполните это поле';
                        };

                        if (!values.role_id) {
                            if (this.state.roles) {
                                values.role_id = String(this.state.roles[0].id);
                            } else {
                                errors.role_id = 'Пожалуйста, заполните это поле';
                            }

                        };

                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        try {

                            // console.log(values);
                            this.props.updateLoader({
                                loaded: false,
                                message: ""
                            });

                            if (this.props.match.params.id == 0) {
                                await api.makeRequest(api.signupUser(values));
                            } else {
                                await api.makeRequest(api.updateUser(this.props.match.params.id, {
                                    fio: values.fio,
                                    email: values.email,
                                    role_id: values.role_id,
                                }));
                            }

                            this.props.updateLoader({
                                loaded: true
                            });

                            this.setState({
                                needRedirect: true
                            });
                        } catch (err) {
                            this.props.updateLoader({
                                loaded: true,
                                message: 'Ошибка сохранения: ' + err
                            });
                        }
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="">
                            <div className="form-group">
                                <label>ФИО</label>
                                <Field className="form-control" type="text" name="fio" />
                                <ErrorMessage className="form-error-message" name="fio" component="div" />
                            </div>
                            <div className="form-group">
                                <label>E-mail</label>
                                <Field className="form-control" type="email" name="email" />
                                <ErrorMessage className="form-error-message" name="email" component="div" />
                            </div>
                            <div className="form-group">
                                <label>Логин</label>
                                <Field className="form-control" type="text" name="login" disabled={this.props.match.params.id != 0} />
                                <ErrorMessage className="form-error-message" name="login" component="div" />
                            </div>

                            {
                                this.props.match.params.id == 0 &&
                                <div className="form-group">
                                    <label>Пароль</label>
                                    <Field className="form-control" type="password" name="password" />
                                    <ErrorMessage className="form-error-message" name="password" component="div" />
                                </div>
                            }

                            <div className="form-group">
                                <label>Роль</label>
                                <Field className="form-control" name="role_id" component="select">
                                    {
                                        this.state.roles && this.state.roles.map((role) => (
                                            <option value={String(role.id)}>{role.name}</option>
                                        ))
                                    }
                                </Field>
                                <ErrorMessage className="form-error-message" name="role_id" component="div" />
                            </div>

                            <button className="btn btn-primary-custom " type="submit">
                                Сохранить
                            </button>
                            <button className="btn btn-secondary ml-2 btn-with-link" type="button">
                                <Link to={this.state.returnUrl}>Назад</Link>
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}

export default UserDetailPage;